import type { BtnListConfig, HeadBtnListConfig } from 'liyu-pc-base/api/typing';
export default (t, { model_app }) => {
  const head_btn_list: HeadBtnListConfig = [
    {
      name: '执行所有任务',
      model_kind: 'confirm',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '执行所有任务',
        content: '是否确认按照处理顺序执行所有任务?',
        ok_url: `${model_app}/exec_task_immediately`,
      },
      preProcessData: ({}) => {
        return {
          export_all: 1,
        };
      },
      order: 1,
      authority: `${model_app}/exec_task_immediately`,
    },
  ];
  const btn_list: BtnListConfig = [
    {
      name: '查询样例数据',
      model_kind: 'custom_component',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '查询原始数据',
        component: 'syncExportRawData',
        init_data: {
          model_app: model_app,
        },
      },
      order: 4,
      authority: `${model_app}/sync_export_raw_data`,
      show_condition: [
        [
          {
            flag: 'is_active',
            type: 'boolean',
            operator: 'eq',
            value: [true],
          },
        ],
      ],
    },
    {
      name: '立即执行',
      model_kind: 'form',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '立即执行',
        ok_url: `${model_app}/exec_task_immediately`,
        api_fields: {
          export_task_id: 'id',
        },
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'vertical',
            col: [],
          },
          dynamicFieldList: [
            {
              children: [
                {
                  type: 'radio',
                  label: '导出方式',
                  disabled: false,
                  valueKey: 'value',
                  labelKey: 'name',
                  name: 'export_all',
                  placeholder: '请选择导出方式',
                  span: 24,
                  pull: 0,
                  push: 0,
                  offset: 0,
                  queryType: 'advanced',
                },
              ],
            },
          ],
          model: {
            export_all: null,
          },
          rules: {},
          options: {
            export_all: [
              {
                valueType: 'int',
                value: 1,
                name: '导出全部剩余数据',
              },
              {
                valueType: 'int',
                value: 0,
                name: '单批次导出',
              },
            ],
          },
        },
        init_data: {
          export_all: 1,
        },
      },
      order: 4,
      authority: `${model_app}/exec_task_immediately`,
      show_condition: [
        [
          {
            flag: 'is_active',
            type: 'boolean',
            operator: 'eq',
            value: [true],
          },
        ],
      ],
    },
    {
      name: '重置任务',
      model_kind: 'confirm',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '重置任务',
        content: '是否确认要重置该任务, 此操作将会重置该任务的增量标记',
        ok_url: `${model_app}/reset_task_last_export`,
        api_fields: {
          export_task_id: 'id',
        },
      },
      order: 4,
      authority: `${model_app}/reset_task_last_export`,
      show_condition: [
        [
          {
            flag: 'is_active',
            type: 'boolean',
            operator: 'eq',
            value: [true],
          },
        ],
      ],
    },
    {
      name: '停止执行',
      model_kind: 'confirm',
      type: 'dropdown',
      clazz: 'primary',
      model_config: {
        title: '停止执行',
        content: '是否确认要停止该任务',
        ok_url: `${model_app}/stop_export_task`,
        api_fields: {
          export_task_id: 'id',
        },
      },
      order: 4,
      authority: `${model_app}/stop_export_task`,
      show_condition: [
        [
          {
            flag: 'is_active',
            type: 'boolean',
            operator: 'eq',
            value: [true],
          },
        ],
      ],
      disabled_condition: [
        [
          {
            flag: 'last_status',
            type: 'str',
            operator: 'not_eq',
            value: ['running'],
          },
        ],
      ],
    },
  ];
  return {
    btn_list: btn_list,
    head_btn_list,
  };
};
